import styled from "styled-components";
import { mainFont, white, black } from "../../utils/StyleHelpers";

export const StyledModalContainerBG = styled.div``;

export const StyledModalContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  width: ${(props: any) => props.width || "40rem"};
  padding: var(--searchBarIconW, 2rem);
  flex-direction: column;
  align-items: flex-start;
  gap: var(--searchBarIconW, 2rem);
  border-radius: 1rem;
  background: ${white};
`;

export const StyledModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  align-self: stretch;
`;

export const StyledModalHeader = styled.div`
  color: ${black};
  align-self: left;
  font-family: ${mainFont};
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.5rem; /* 100% */
`;

export const StyledModalBody = styled.div`
  color: ${black};
  text-align: left;
  font-family: ${mainFont};
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem; /* 120% */
  width: 100%;
`;

export const StyledModalSubBody = styled.div`
  color: ${black};
  text-align: center;
  font-family: ${mainFont};
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem; /* 120% */
  width: 100%;
  max-height: 30vh;
  overflow-y: scroll;
`;

export const StyledModalFooter = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  align-self: stretch;
`;
